import { type FunctionComponent, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  req,
  selectSurvey,
  selectSurveyStatus,
  selectSurveyError,
  hasAccessSelector,
} from "../../redux/survey/surveySlice";
import { SurveyAsset } from "..";
import { SendPageView } from "../../../Application/services/realTimeNotification/googleAnalytics";
import { FixedHeightAppPageWrapper } from "../../../Application/layout";
import { FetchingLayout } from "../../../Application/layout/FetchingLayout/FetchingLayout";
import { ErrorType, HttpErrorView } from "../../../Application/layout/HttpErrorView/HttpErrorView";

import styles from "./SurveyDetailsPage.module.scss";
import { useFromAdminErrorAction } from "features/Assets/hooks/useFromAdminErrorAction";
import { EntityType } from "features/common/types";

interface SurveyDetailsPageProps {}

export const SurveyDetailsPage: FunctionComponent<SurveyDetailsPageProps> = () => {
  let { surveyId } = useParams();
  const dispatch = useDispatch();
  const survey = useSelector(selectSurvey);
  const status = useSelector(selectSurveyStatus);
  const errorMessage = useSelector(selectSurveyError);
  const hasAccess = useSelector(hasAccessSelector);

  const { action, message, actionText } = useFromAdminErrorAction(EntityType.Survey, surveyId, hasAccess);

  useEffect(() => {
    if (survey?.title) {
      document.title = survey.title;
      SendPageView();
    }
  }, [survey]);

  useEffect(() => {
    if (surveyId) {
      dispatch(req({ id: Number(surveyId) }));
    }
  }, [dispatch, surveyId]);

  return (
    <FixedHeightAppPageWrapper>
      <FetchingLayout status={status} errorMessage={errorMessage}>
        <div className={styles.root}>
          {hasAccess && survey ? (
            <SurveyAsset survey={survey} />
          ) : (
            <HttpErrorView
              code={ErrorType.Forbidden}
              back={!action}
              action={action}
              message={message}
              actionText={actionText}
            />
          )}
        </div>
      </FetchingLayout>
    </FixedHeightAppPageWrapper>
  );
};

export default SurveyDetailsPage;
